/**
 * QR Code Block - Save Component
 *
 * Stores QR parameters as data attributes; view.js generates the SVG on the frontend
 * using qrcode-generator (pure synchronous JS, no React dependency).
 * This avoids React hook conflicts during Gutenberg block validation.
 *
 * @package BrandyBlocks
 */

import { useBlockProps } from '@wordpress/block-editor';

/**
 * Save component.
 *
 * @param {Object} props
 * @param {Object} props.attributes
 */
export default function save( { attributes } ) {
	const { content, size, fgColor, bgColor, quietZone, caption, showDownload } = attributes;

	if ( ! content ) {
		return null;
	}

	const blockProps = useBlockProps.save( {
		className: 'brandy-qr',
		'data-qr-content': content,
		'data-qr-size': size,
		'data-qr-fg': fgColor,
		'data-qr-bg': bgColor,
		'data-qr-margin': quietZone,
		style: { '--brandy-qr-fg': fgColor },
	} );

	return (
		<div { ...blockProps }>
			{ caption && <p className="brandy-qr__caption">{ caption }</p> }
			{ showDownload && (
				<button type="button" className="brandy-qr__download">
					Download QR
				</button>
			) }
		</div>
	);
}
